import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-duwnarrows",
  "use": "icon-duwnarrows-usage",
  "viewBox": "0 0 11 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 19\" id=\"icon-duwnarrows\">\r\n  <defs>\r\n    <style>\r\n      #icon-duwnarrows .cls-1 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n    </style>\r\n  </defs>\r\n  <path id=\"icon-duwnarrows_下降\" class=\"cls-1\" d=\"M802.987,333v10.833H807l-5.507,8.174-5.506-8.174h4.016V333h2.981Z\" transform=\"translate(-796 -333)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/duwnarrows.svg
// module id = eBPU
// module chunks = 127